import React, { useEffect } from 'react'
import { Image, TouchableOpacity, Platform, View, ViewStyle } from 'react-native'
import { color } from '../../theme'
import { Banner } from '../banner'
import { Medallion } from '../medallion'
import { RecallWheel } from '../recall-wheel'
import { Text } from '../text'
import { useTranslation } from 'react-i18next'

interface TopicHeaderProps {
  certification?: string | null
  recall?: number | null
  backgroundImage?: string | undefined | null
  hasCertification?: boolean
  topicComplete?: boolean
  boost?: boolean
  onPress?: () => void
  disabled?: boolean
  badge?: any
  showCert?: any
}
export const TopicHeader = (props: TopicHeaderProps) => {
  const {
    onPress,
    certification,
    boost,
    topicComplete,
    backgroundImage,
    recall,
    disabled,
    badge,
    showCert,
  } = props

  const { t } = useTranslation()

  const levelTx = t(`Certifications.${certification?.toLowerCase()}`)

  return showCert && certification ? (
    <TouchableOpacity style={{ elevation: 1 }} disabled={disabled} onPress={onPress}>
      <Banner
        style={{
          borderColor: color.shade10,
          borderWidth: 1,
          borderRadius: 20,
          marginBottom: 12,
        }}
        backgroundImage={undefined}
      >
        <View style={CONTAINER}>
          <Medallion
            style={{ zIndex: 9999, position: 'relative', right: 16 }}
            type={certification}
            recall={recall}
            scale={0.74}
          />
          {badge && topicComplete ? (
            <Image
              style={{
                width: 70,
                height: 70,
                borderRadius: 100,
                left: -72,
              }}
              source={{ uri: badge?.icon_url }}
            />
          ) : null}
          <View style={{ ...CERT_TEXT, width: badge ? '70%' : '80%', left: badge ? -60 : -8 }}>
            <Text
              variant="titleEmphasized"
              tx="Certifications.complete_cert"
              txOptions={{ level: certification !== null ? levelTx : '' }}
              // text={certification ? `${certification} Certified` : 'No Certification Earned'}
            />
            <Text
              style={{ color: '#54585b' }}
              adjustsFontSizeToFit
              variant="body1"
              tx={
                certification
                  ? boost
                    ? 'Topic.certificationRecallBoost'
                    : 'Topic.certificationRecall'
                  : 'Topic.noCert'
              }
              txOptions={{ recall: recall ? Number(Math.round(recall * 100).toFixed(0)) : 0 }}
            />
          </View>
        </View>
      </Banner>
    </TouchableOpacity>
  ) : topicComplete ? (
    <TouchableOpacity style={{ elevation: 1 }} disabled={disabled} onPress={onPress}>
      <Banner
        style={{
          borderWidth: 2,
          borderColor: Platform.OS === 'web' ? color.shade10 : 'rgba(255,255,255,.5)',
          borderRadius: 20,
          marginBottom: 12,
        }}
        backgroundImage={backgroundImage ?? undefined}
      >
        <View style={CONTAINER}>
          {badge ? (
            <Image
              style={{
                width: 70,
                height: 70,
                borderRadius: 100,
              }}
              source={{ uri: badge?.icon_url }}
            />
          ) : (
            <RecallWheel
              variant="large"
              circleColour="rgb(129, 52, 254)"
              iconColour="rgb(129, 52, 254)"
              strokeColor="rgb(216, 202, 254)"
              value={recall}
              icon="check"
              style={RECALL_WHEEL}
            />
          )}
          <View style={{ ...RECALL_TEXT, left: badge ? 16 : Platform.OS === 'web' ? 72 : 16 }}>
            <Text variant="titleEmphasized" tx="Topic.complete" />
            <Text
              style={{ color: '#54585b' }}
              variant="body1"
              tx="Topic.recallText"
              txOptions={{ recall: recall ? Number(Math.round(recall * 100).toFixed(0)) : 0 }}
            />
          </View>
        </View>
      </Banner>
    </TouchableOpacity>
  ) : null
}

const CONTAINER: ViewStyle = {
  flex: 1,
  padding: 14,
  paddingRight: 32,
  flexDirection: 'row',
  width: '100%',
  zIndex: 999,
  alignItems: 'center',
  elevation: 2,
}
const CERT_TEXT: ViewStyle = {
  // flex: 1,
  width: '80%',
  justifyContent: 'center',
  flexDirection: 'column',
  left: -60,
}
const RECALL_TEXT: ViewStyle = { ...CERT_TEXT, left: Platform.OS === 'web' ? 80 : 16 }
const RECALL_WHEEL: ViewStyle = { display: 'flex', flex: 0, flexShrink: 0 }
